angular.module('PatientApp').directive('loyal', function() {
    return {
        restrict: 'E',
        scope: {
            clientId: '@'
        },
        templateUrl: 'templates/modals/loyal-directive-modal.tpl.html',
        bindToController: true,
        controller: 'LoyalCtrl'
    };
});